import { useArticleStore } from "~/store/article";

export default defineNuxtRouteMiddleware(async (to, from) => {
  const articleStore = useArticleStore();
  if (articleStore.categories.length === 0) {
    await articleStore.getCategories();
  }
  const category = articleStore.categories.find(
    (category) => category.frontRoute === to.params.cat
  );
  if (!category) {
    return navigateTo("/");
  }
});
